import React from "react";

interface LoaderProps {
  fullscreen?: boolean;
  size?: "sm" | "md" | "lg";
  color?: string; // Use default text color if not provided
  className?: string;
  style?: React.CSSProperties;
}

const sizeClassMap = {
  sm: "spinner-border spinner-border-sm",
  md: "spinner-border",
  lg: "spinner-border spinner-border-lg",
};

const Loader: React.FC<LoaderProps> = ({
  fullscreen = true,
  size = "lg",
  color = "", // Inherit default text color
  className = "",
  style = {},
}) => {
  const spinnerClass = sizeClassMap[size] || "spinner-border";
  const colorClass = color ? `text-${color}` : "";

  const spinner = (
    <div className={`${spinnerClass} ${colorClass}`} role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );

  if (fullscreen) {
    return (
      <div
        className={`position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 menuCrlBtn ${className}`}
        style={{ zIndex: 9999, ...style }}
      >
        {spinner}
      </div>
    );
  }

  return (
    <div
      className={`d-flex justify-content-center align-items-center ${className}`}
       style={{ minHeight: "40vh", ...style }}
    >
      {spinner}
    </div>
  );
};

export default Loader;
